import { Component, Input, Output, EventEmitter, TemplateRef, ContentChild, ViewEncapsulation } from '@angular/core';
import { ListingTableColumn } from '../interfaces/listing.interface';

@Component({
  selector: 'app-listing-table',
  templateUrl: './listing-table.component.html',
  styleUrls: ['./listing-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListingTableComponent {
  @Input() columns: ListingTableColumn[] = [];
  @Input() data: any[] = [];
  @Input() sortField?: string;
  @Input() sortOrder?: 'asc' | 'desc';
  @Input() isLoading: boolean = false;
  @Input() useCustomRows: boolean = false; // If true, use ng-content; if false, auto-render rows
  @Input() getRowClass?: (item: any) => string | string[]; // Function to get row classes
  
  @ContentChild(TemplateRef) rowTemplate?: TemplateRef<any>;
  
  @Output() sortChange = new EventEmitter<{ field: string; order: 'asc' | 'desc' }>();
  @Output() rowClick = new EventEmitter<any>();

  onSort(field: string): void {
    if (!this.columns.find(col => col.key === field)?.sortable) {
      return;
    }

    let newOrder: 'asc' | 'desc' = 'asc';
    if (this.sortField === field && this.sortOrder === 'asc') {
      newOrder = 'desc';
    } else if (this.sortField === field && this.sortOrder === 'desc') {
      // Reset sorting
      this.sortField = undefined;
      this.sortOrder = undefined;
      this.sortChange.emit({ field: '', order: 'asc' });
      return;
    }

    this.sortField = field;
    this.sortOrder = newOrder;
    this.sortChange.emit({ field, order: newOrder });
  }

  getSortIcon(field: string): string {
    if (this.sortField !== field) {
      return 'fa-sort text-muted';
    }
    return this.sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  getCellValue(item: any, column: ListingTableColumn): any {
    if (column.render) {
      return column.render(item);
    }
    // Support nested properties like 'user.name'
    const keys = column.key.split('.');
    let value = item;
    for (const key of keys) {
      value = value?.[key];
    }
    return value ?? '';
  }

  getRowClasses(item: any): string {
    if (this.getRowClass) {
      const classes = this.getRowClass(item);
      return Array.isArray(classes) ? classes.join(' ') : classes;
    }
    return '';
  }

  onRowClick(item: any): void {
    this.rowClick.emit(item);
  }

  trackByFn(index: number, item: any): any {
    return item?.id || item?.networkID || item?.userID || index;
  }
}
